import { createStyles, makeStyles, Theme } from "@material-ui/core";

export const useStylesAdminUsers = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      padding: '40px 16px 80px',
      margin: '0 auto',
      boxSizing: 'border-box',
      maxWidth: '1320px',
      minHeight: 'calc(100vh - 104px)',
      height: 'auto',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      [theme.breakpoints.down(1024)]: {
        paddingBottom: '230px'
      },
      [theme.breakpoints.down(760)]: {
        padding: '24px 8px 230px',
      },
    },
    content: {
      width: '100%',
      maxWidth: '1160px',
      [theme.breakpoints.down(1024)]: {
        maxWidth: '800px',
      },
    },
  }))